import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'text',
        name: 'title',
        title: i18n.t('account.note.title'),
        rules: {required: true},
        options: false,
        modal: ['name'],
        data: ['name',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'radio',
        name: 'every_year',
        title: i18n.t('account.vacation.yearIndependent'),
        rules: {},
        default: false,
        options: {
            type: 'locale',
            data: [
                {text: i18n.t('general.no'), value: false},
                {text: i18n.t('general.yes'), value: true},
            ],
        },
        modal: ['is_every_year'],
        data: ['is_every_year'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'date',
        name: 'beginDate',
        title: i18n.t('account.vacation.beginDate'),
        format:"YYYY-MM-DD",
        rules: {required: true},
        modal: ['begin_date'],
        data: ['begin_date'],
        nextField: 'endDate',
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'date',
        name: 'endDate',
        title: i18n.t('account.vacation.endDate'),
        format:"YYYY-MM-DD",
        rules: {required: true},
        modal: ['end_date'],
        data: ['end_date'],
        additionalButton: false,
        checkBox: false
    },
    
 
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/Alarmsis/Account/forms/vacation.js